import {Request} from "mssql";
import {ApplicationScope} from "../ApplicationScope";
import {PatientSyncR4Message} from "../R4Message";
import {R4MedicalQuestionnaire, R4Patient} from "../R4Patient";
import {R4PatientSyncData} from "./R4PatientSyncData";

export const patientSync = async (applicationScope: ApplicationScope, message: PatientSyncR4Message) => {
  try {

    const req: Request = await applicationScope.connectionPool.request();

    req.input('patientCode', message.r4PatientId);

    /*
    CompletedQuestionnaire.state - not totally clear what this means. Something to do with current/first questionnaire

    CompletedQuestionnaireAnswer.Notes - always seems to be null
    CompletedQuestionnaireAnswer.TextAnswer - always seems to be null. Deprecated?
    CompletedQuestionnaireAnswer.CurrencyAnswer - always seems to be null. Deprecated?
    CompletedQuestionnaireAnswer.DateAnswer - always seems to be null. Deprecated?
     */
    const result = await req
      .query(`
  SELECT 
      p.patientCode as patient_code,
      p.surname as family_name,
      p.forename as given_name,
      convert(varchar, p.dob, 23) as date_of_birth,
      p.mobileNo as mobile_number,
      p.email as email_address,
      a.address1 as address_line_1,
      a.address2 as address_line_2,
      a.address3 as address_line_3,
      a.address4 as address_line_4,
      a.address5 as address_line_5,
      a.postcode,
      
      cq.qaireid as questionnaire_id,
      cq.datetime as questionnaire_date_time,
      q.text as question_text,
      cqma.text as answer_text,
      cq.notes as questionnaire_notes,
      cqa.notes as answer_notes
      
    FROM patients p 
      left join addresses a on p.addressId = a.addressId
      left join CompletedQuestionnaire cq on cq.patientCode = p.patientCode
      left join CompletedQuestionnaireAnswer cqa on cqa.qaireid = cq.qaireid
      left join QuestionMultiAnswer cqma on cqma.AnswerId = cqa.AnswerId
      left join Question q on q.QuestionId = cqa.QuestionId
      
    WHERE 
      p.patientCode = @patientCode and
      (cq.qaireid = (select max(qaireid) from CompletedQuestionnaire cq2 where cq2.patientcode=@patientCode) or cq.qaireid is null)
    `);

    if (result.recordset.length === 0) {
      applicationScope.logging.log({
          message: `Patient not found with ID "${message.r4PatientId}"`
        },
        'error');
      return;
    }

    const firstRow = result.recordset[0];

    const addressLine3 = firstRow['address_line_3'];
    const addressLine4 = firstRow['address_line_4'];
    const addressLine5 = firstRow['address_line_5'];

    const patient: R4Patient = {
      id: firstRow['patient_code'].toString(),
      familyName: firstRow['family_name'],
      givenName: firstRow['given_name'],
      dateOfBirth: firstRow['date_of_birth'],
      mobileNumber: firstRow['mobile_number'] || null,
      emailAddress: firstRow['email_address'] || null,
      addressLine1: firstRow['address_line_1'],
      addressLine2: firstRow['address_line_2'],
      city: addressLine3 && addressLine4 ? `${addressLine3}, ${addressLine4}` : (addressLine3 || addressLine4),
      county: addressLine5,
      postcode: firstRow['postcode'],

      // Hard-coded
      country: 'UK'
    };

    let questionnaire: R4MedicalQuestionnaire | null = null;

    // Check that the patient has a questionnaire
    if (firstRow['questionnaire_id']) {
      questionnaire = {
        submissionTime: firstRow['questionnaire_date_time'],
        notes: firstRow['questionnaire_notes'],
        responses: result.recordset.map((row) => ({
          questionText: row['question_text'],
          answerText: row['answer_text'],
          answerNotes: row['answer_notes'],
        }))
      }
    }

    const syncData: R4PatientSyncData = {patient, questionnaire, patientPatchId: message.patientPatchId};

    await applicationScope.flynotesServer.patientSync(syncData, applicationScope.licenceKey);
  } catch (e) {

    applicationScope.logging.log({
      message: 'Patient sync failed',
      error: e
    },
      'error')
  }
};
